import { combineReducers } from "redux";
import constants from "modules/main/constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  authAdproResult: createApiReducer(constants.AUTH_ADPRO, {}),
  currentAd: createApiReducer(constants.AD, {}),
  currentFacebookAd: createApiReducer(constants.FACEBOOK_AD, {}),
  currentDashboardResult: createApiReducer(constants.CURRENT_DASHBOARD, "google"),
  loginToRdynamicResult: createApiReducer(constants.LOGIN_TO_RDYNAMIC, {}),
  checkAppAvailableResult: createApiReducer(constants.CHECK_APP_AVAILABLE, {}),
  getNexusUserInfoResult: createApiReducer(constants.GET_NEXUS_USER_INFO, {}),
});

export default reducers;
